import { sbaAxios } from "../utils/sbaAxios";
import { getCurrentUserDetails,getFamilies, getManagerContactsList, getDSList, getEnumerations, getAssetListByTermApi, getTaxEntities, getCustomSettings, getLiquidityRequiredNotice, getLiquidityLockType, getLiquidityLockupFrequency, getFrequencies, getCommon } from "../../config/apiConfig";
import {
    FETCH_MANAGER_BEGIN,
    FETCH_MANAGER_SUCCESS,
    FETCH_MANAGER_FAILURE,
    FETCH_USERDETAILS_BEGIN,
    FETCH_USERDETAILS_SUCCESS,
    FETCH_USERDETAILS_FAILURE,
    FETCH_DS_BEGIN,
    FETCH_DS_SUCCESS,
    FETCH_DS_FAILURE,
    FETCH_ENUM_BEGIN,
    FETCH_ENUM_SUCCESS,
    FETCH_ENUM_FAILURE,
    FETCH_ACTIVEMENU_SUCCESS,
    FETCH_ASSETLIST_SEARCH_BEGIN,
    FETCH_ASSETLIST_SEARCH_SUCCESS,
    FETCH_ASSETLIST_SEARCH_FAILURE,
    FETCH_ACTIVESUBMENU_SUCCESS,

    FETCH_CONTACT_BEGIN,
    FETCH_CONTACTLEAD_SUCCESS,
    FETCH_CONTACTRANK_SUCCESS,
    FETCH_CONTACTREPTYPE_SUCCESS,
    FETCH_CONTACTUPDATESTATUS_SUCCESS,
    FETCH_CONTACTCATEGORY_SUCCESS,

    FETCH_TAXENTITIES_BEGIN,
    FETCH_TAXENTITIES_SUCCESS,
    FETCH_TAXENTITIES_FAILURE,
    FETCH_DEFAULTENTITIES_BEGIN,
    FETCH_DEFAULTENTITIES_SUCCESS,
    FETCH_DEFAULTENTITIES_FAILURE,
    FETCH_LIQUIDITYREQUIREDNOTICE_BEGIN,
    FETCH_LIQUIDITYREQUIREDNOTICE_SUCCESS,
    FETCH_LIQUIDITYREQUIREDNOTICE_FAILURE,
    FETCH_LIQUIDITYLOCKTYPE_BEGIN,
    FETCH_LIQUIDITYLOCKTYPE_SUCCESS,
    FETCH_LIQUIDITYLOCKTYPE_FAILURE,
    FETCH_LIQUIDITYLOCKUPFREQUENCY_BEGIN,
    FETCH_LIQUIDITYLOCKUPFREQUENCY_SUCCESS,
    FETCH_LIQUIDITYLOCKUPFREQUENCY_FAILURE,
    FETCH_FREQUENCY_1_BEGIN,
    FETCH_FREQUENCY_1_FAILURE,
    FETCH_FREQUENCY_1_SUCCESS,
    FETCH_FREQUENCY_2_FAILURE,
    FETCH_FREQUENCY_2_SUCCESS,
    FETCH_FREQUENCY_2_BEGIN,
    FETCH_FAMILIES_FAILURE,
    FETCH_FAMILIES_SUCCESS,
    FETCH_FAMILIES_BEGIN,
    FETCH_STATES_BEGIN,
    FETCH_STATES_SUCCESS,
    FETCH_STATES_FAILURE,
    FETCH_COUNTRY_BEGIN,
    FETCH_COUNTRY_SUCCESS,
    FETCH_COUNTRY_FAILURE,
} from '../constants/Common';

export const getManagerContacts = () => {
    return (dispatch) => {
        dispatch(fetchUserBegin());
        sbaAxios({
            url: `${getManagerContactsList}`,
            method: 'get',
        })
            .then((repos) => {
                const Manager = [{
                    "ManagerContactId": null,
                    "ManagerContact": "--Please Select--"
                }, ...repos];
                dispatch(fetchUserSuccess(Manager));
                return Manager;
            })
            .catch((error) => dispatch(fetchUserFailure(error)));
    };
}

export const fetchUserBegin = () => ({
    type: FETCH_MANAGER_BEGIN,
});

export const fetchUserSuccess = (managerContacts) => ({
    type: FETCH_MANAGER_SUCCESS,
    payload: { managerContacts },
});


export const fetchUserFailure = (errorMessage) => ({
    type: FETCH_MANAGER_FAILURE,
    payload: { errorMessage }
});


export const getUserDetails = (mailID) => {
    return async (dispatch) => {
        try {
            dispatch(fetchUserDetailsBegin());
            const repos = await sbaAxios({
                url: `${getCurrentUserDetails}${mailID}`,
                method: 'get',
            });
            const userDetails = repos;
            dispatch(fetchUserDetailsSuccess(userDetails));
            return userDetails;
        } catch (error) {
            dispatch(fetchUserDetailsFailure(error));
        }
    };
}


export const fetchUserDetailsBegin = () => ({
    type: FETCH_USERDETAILS_BEGIN,
});

export const fetchUserDetailsSuccess = (userDetails) => ({
    type: FETCH_USERDETAILS_SUCCESS,
    payload: { userDetails },
});


export const fetchUserDetailsFailure = (errorMessage) => ({
    type: FETCH_USERDETAILS_FAILURE,
    payload: { errorMessage }
});


export const getDataSource = (TypeId) => {
    return (dispatch) => {
        dispatch(fetchDSBegin());
        sbaAxios({
            url: `${getDSList}${TypeId}`,
            method: 'get',
        })
            .then((repos) => {
                const DataSource = repos;
                dispatch(fetchDSSuccess(DataSource));
                return DataSource;
            })
            .catch((error) => dispatch(fetchDSFailure(error)));
    };
}

export const fetchDSBegin = () => ({
    type: FETCH_DS_BEGIN,
});

export const fetchDSSuccess = (DataSourcelist) => ({
    type: FETCH_DS_SUCCESS,
    payload: { DataSourcelist },
});


export const fetchDSFailure = (errorMessage) => ({
    type: FETCH_DS_FAILURE,
    payload: { errorMessage }
});



export const getEnumeration = (Type) => {
  return (dispatch) => {
    dispatch(fetchEnumBegin());
    sbaAxios({
      url: `${getEnumerations}${Type}`,
      method: "get",
    })
      .then((repos) => {
        const EnumData = repos;
        dispatch(fetchEnumSuccess(EnumData));
        return EnumData;
      })
      .catch((error) => dispatch(fetchEnumFailure(error)));
  };
};

export const fetchEnumBegin = () => ({
    type: FETCH_ENUM_BEGIN,
});

export const fetchEnumSuccess = (enumValues) => ({
    type: FETCH_ENUM_SUCCESS,
    payload: { enumValues },
});

export const getContactLeadAction = (Type) => {
  return async (dispatch) => {
    dispatch(getContactActionBegin());
    try {
      const response = await sbaAxios({
        url: `${getEnumerations}${Type}`,
        method: "get",
      });
      const ContactLeadData = response;
      dispatch(getContactLeadActionSuccess(ContactLeadData));
    } catch (error) {
      if (error.message === "Network Error") {
        dispatch(getContactLeadActionSuccess({}));
      } else {
        dispatch(fetchEnumFailure(error));
      }
    }
  };
};

export const getContactRankAction = (Type) => {
  return async (dispatch) => {
    dispatch(getContactActionBegin());
    try {
      const response = await sbaAxios({
        url: `${getEnumerations}${Type}`,
        method: "get",
      });
      const ContactRankData = response;
      dispatch(getContactRankActionSuccess(ContactRankData));
    } catch (error) {
      if (error.message === "Network Error") {
        dispatch(getContactRankActionSuccess({}));
      } else {
        dispatch(fetchEnumFailure(error));
      }
    }
  };
};

export const getContactRepTypeAction = (Type) => {
  return async (dispatch) => {
    dispatch(getContactActionBegin());
    try {
      const response = await sbaAxios({
        url: `${getEnumerations}${Type}`,
        method: "get",
      });
      const ContactRepTypeData = response;
      dispatch(getContactRepTypeActionSuccess(ContactRepTypeData));
    } catch (error) {
      if (error.message === "Network Error") {
        dispatch(getContactRepTypeActionSuccess({}));
      } else {
        dispatch(fetchEnumFailure(error));
      }
    }
  };
};

export const getContactUpdateStatusAction = (Type) => {
  return async (dispatch) => {
    dispatch(getContactActionBegin());
    try {
      const response = await sbaAxios({
        url: `${getEnumerations}${Type}`,
        method: "get",
      });
      const ContactUpdateStatusData = response;
      dispatch(getContactUpdateStatusActionSuccess(ContactUpdateStatusData));
    } catch (error) {
      if (error.message === "Network Error") {
        dispatch(getContactUpdateStatusActionSuccess({}));
      } else {
        dispatch(fetchEnumFailure(error));
      }
    }
  };
};

export const getContactCategoryAction = (Type) => {
  return async (dispatch) => {
    dispatch(getContactActionBegin());
    try {
      const response = await sbaAxios({
        url: `${getEnumerations}${Type}`,
        method: "get",
      });
      const ContactCategoryData = response;
      dispatch(getContactCategoryActionSuccess(ContactCategoryData));
    } catch (error) {
      if (error.message === "Network Error") {
        dispatch(getContactCategoryActionSuccess({}));
      } else {
        dispatch(fetchEnumFailure(error));
      }
    }
  };
};

export const getContactActionBegin = () => ({
    type: FETCH_CONTACT_BEGIN,
});

export const getContactLeadActionSuccess = (ContactLeadData) => ({
    type: FETCH_CONTACTLEAD_SUCCESS,
    payload: { ContactLeadData },
});

export const getContactRankActionSuccess = (ContactRankData) => ({
    type: FETCH_CONTACTRANK_SUCCESS,
    payload: { ContactRankData },
});

export const getContactRepTypeActionSuccess = (ContactRepTypeData) => ({
    type: FETCH_CONTACTREPTYPE_SUCCESS,
    payload: { ContactRepTypeData },
});

export const getContactUpdateStatusActionSuccess = (ContactUpdateStatusData) => ({
    type: FETCH_CONTACTUPDATESTATUS_SUCCESS,
    payload: { ContactUpdateStatusData },
});

export const getContactCategoryActionSuccess = (ContactCategoryData) => ({
    type: FETCH_CONTACTCATEGORY_SUCCESS,
    payload: { ContactCategoryData },
});


export const fetchEnumFailure = (errorMessage) => ({
    type: FETCH_ENUM_FAILURE,
    payload: { errorMessage }
});

export const setActiveMenu=(menuID)=>{
    return (dispatch) => {
        dispatch(fetchActiveMenuSuccess(menuID));
    }
}
export const fetchActiveMenuSuccess=(menuID)=>({
    type :FETCH_ACTIVEMENU_SUCCESS,
    payload :{menuID}
});
export const setActiveSubMenu=(parentMenuID,menuID)=>{
    return (dispatch) => {
        dispatch(setActiveSubMenuSuccess(parentMenuID,menuID));
    }
}
export const setActiveSubMenuSuccess=(parentMenuID,menuID)=>({
    type :FETCH_ACTIVESUBMENU_SUCCESS,
    payload :{parentMenuID,menuID}
});

// fetch asset List by search term action begin
export const getAssetListByTerm = (searchTerm) => {
    return (dispatch) => {
        dispatch(getAssetListByTermBegin());
        sbaAxios({
            url: `${getAssetListByTermApi}${searchTerm}`,
            method: 'get',
        })
            .then((repos) => {
                const AssetList = repos;
                //Add logic to format the DataItem if needed using map
                dispatch(getAssetListByTermSuccess(AssetList));
                return AssetList;
            })
            .catch((error) => dispatch(getAssetListByTermFailure(error)));
    };
}
export const getAssetListByTermBegin = () => ({
    type: FETCH_ASSETLIST_SEARCH_BEGIN,
});

export const getAssetListByTermSuccess = (assetItems) => ({
    type: FETCH_ASSETLIST_SEARCH_SUCCESS,
    payload: { assetItems },
});

export const getAssetListByTermFailure = (errorMessage) => ({
    type: FETCH_ASSETLIST_SEARCH_FAILURE,
    payload: { errorMessage }
});
// fetch asset List by search term action end

export const getTaxEntitiesAction = (searchTerm) => {
  return async (dispatch) => {
      dispatch(getTaxEntitiesBegin());
      try {
        const response = await
      sbaAxios({
          url: `${getTaxEntities}${searchTerm}`,
          method: 'get',
      })
      const TaxEntitiesList = response;
      dispatch(getTaxEntitiesSuccess(TaxEntitiesList));
    }
    catch (error) {
      if (error.message === "Network Error") {
        dispatch(getTaxEntitiesSuccess({}));
      }
    else{
      dispatch(getTaxEntitiesFailure(error));
    }
    }
  }
}

export const getTaxEntitiesBegin = () => ({
  type: FETCH_TAXENTITIES_BEGIN,
});

export const getTaxEntitiesSuccess = (TaxEntitiesList) => ({
  type: FETCH_TAXENTITIES_SUCCESS,
  payload: { TaxEntitiesList },
});

export const getTaxEntitiesFailure = (errorMessage) => ({
  type: FETCH_TAXENTITIES_FAILURE,
  payload: { errorMessage }
});


export const getDefaultEntities = () => {
  return async (dispatch) => {
      dispatch(getDefaultEntitiesBegin());
      try {
        const response = await sbaAxios({url: `${getCustomSettings}1006`});
        const defaultIds=JSON.parse(response.CustomSettingsValue);
        const transformedObject = defaultIds.reduce((result, item) => {
            result[item.SettingName] = item.Value;
            return result;
          }, {});
      localStorage.setItem("Entities",JSON.stringify(transformedObject));
      dispatch(getDefaultEntitiesSuccess(transformedObject));
    }
    catch (error) {
      if (error.message === "Network Error") {
        dispatch(getDefaultEntitiesSuccess(null));
      }
    else{
      dispatch(getDefaultEntitiesFailure(error));
    }
    }
  }
}

export const getDefaultEntitiesBegin = () => ({
  type: FETCH_DEFAULTENTITIES_BEGIN,
});

export const getDefaultEntitiesSuccess = (entites) => ({
  type: FETCH_DEFAULTENTITIES_SUCCESS,
  payload: { entites },
});

export const getDefaultEntitiesFailure = (errorMessage) => ({
  type: FETCH_DEFAULTENTITIES_FAILURE,
  payload: { errorMessage }
});



export const getLiquidityRequiredNoticeAction = () => {
  return async (dispatch) => {
    dispatch(getLiquidityRequiredNoticeBegin());
    try {
      const response = await
        sbaAxios({
          url: `${getLiquidityRequiredNotice}`,
          method: 'get',
        });
      dispatch(getLiquidityRequiredNoticeSuccess(response));
    }
    catch (error) {
        dispatch(getLiquidityRequiredNoticeFailure(error));
    }
  }
};

export const getLiquidityRequiredNoticeBegin = () => ({
  type: FETCH_LIQUIDITYREQUIREDNOTICE_BEGIN,
});

export const getLiquidityRequiredNoticeSuccess = (RequriedNotice) => ({
  type: FETCH_LIQUIDITYREQUIREDNOTICE_SUCCESS,
  payload: { RequriedNotice },
});

export const getLiquidityRequiredNoticeFailure = (errorMessage) => ({
  type: FETCH_LIQUIDITYREQUIREDNOTICE_FAILURE,
  payload: { errorMessage }
});


export const getLiquidityLockTypeAction = () => {
  return async (dispatch) => {
    dispatch(getLiquidityLockTypeBegin());
    try {
      const response = await
        sbaAxios({
          url: `${getLiquidityLockType}`,
          method: 'get',
        });
      dispatch(getLiquidityLockTypeSuccess(response));
    }
    catch (error) {
        dispatch(getLiquidityLockTypeFailure(error));
    }
  }
};


export const getLiquidityLockTypeBegin = () => ({
  type: FETCH_LIQUIDITYLOCKTYPE_BEGIN,
});

export const getLiquidityLockTypeSuccess = (LockType) => ({
  type: FETCH_LIQUIDITYLOCKTYPE_SUCCESS,
  payload: { LockType },
});

export const getLiquidityLockTypeFailure = (errorMessage) => ({
  type: FETCH_LIQUIDITYLOCKTYPE_FAILURE,
  payload: { errorMessage }
});



export const getLiquidityLockupFrequencyAction = () => {
  return async (dispatch) => {
    dispatch(getLiquidityLockupFrequencyBegin());
    try {
      const response = await
        sbaAxios({
          url: `${getLiquidityLockupFrequency}`,
          method: 'get',
        });
      dispatch(getLiquidityLockupFrequencySuccess([{
        "EnumValue": 0,
        "EnumName": "Please Select",
        "EnumShortName": "",
        "EnumDescription": "",
        "SortOrder": 2
      },...response]));
    }
    catch (error) {
        dispatch(getLiquidityRequiredNoticeFailure(error));
    }
  }
};


export const getLiquidityLockupFrequencyBegin = () => ({
  type: FETCH_LIQUIDITYLOCKUPFREQUENCY_BEGIN,
});

export const getLiquidityLockupFrequencySuccess = (LockUpFrequency) => ({
  type: FETCH_LIQUIDITYLOCKUPFREQUENCY_SUCCESS,
  payload: { LockUpFrequency },
});

export const getLiquidityLockupFrequencyFailure = (errorMessage) => ({
  type: FETCH_LIQUIDITYLOCKUPFREQUENCY_FAILURE,
  payload: { errorMessage }
});



export const getFrequencies1Action = () => {
  return async (dispatch) => {
    dispatch(getFrequencies1ActionBegin());
    try {
      const response = await
        sbaAxios({
          url: `${getFrequencies}1`,
          method: 'get',
        });
      const formattedResponse = response.filter(item => item.FrequencyId !== 0);
      dispatch(getFrequencies1ActionSuccess(formattedResponse));
    }
    catch (error) {
        dispatch(getFrequencies1ActionFailure(error));
    }
  }
};


export const getFrequencies1ActionBegin = () => ({
  type: FETCH_FREQUENCY_1_BEGIN,
});

export const getFrequencies1ActionSuccess = (Frequency) => ({
  type: FETCH_FREQUENCY_1_SUCCESS,
  payload: { Frequency },
});

export const getFrequencies1ActionFailure = (errorMessage) => ({
  type: FETCH_FREQUENCY_1_FAILURE,
  payload: { errorMessage }
});


export const getFrequencies2Action = () => {
  return async (dispatch) => {
    dispatch(getFrequencies2ActionBegin());
    try {
      const response = await
        sbaAxios({
          url: `${getFrequencies}2`,
          method: 'get',
        });
      dispatch(getFrequencies2ActionSuccess(response));
    }
    catch (error) {
        dispatch(getFrequencies2ActionFailure(error));
    }
  }
};


export const getFrequencies2ActionBegin = () => ({
  type: FETCH_FREQUENCY_2_BEGIN,
});

export const getFrequencies2ActionSuccess = (Frequency) => ({
  type: FETCH_FREQUENCY_2_SUCCESS,
  payload: { Frequency },
});

export const getFrequencies2ActionFailure = (errorMessage) => ({
  type: FETCH_FREQUENCY_2_FAILURE,
  payload: { errorMessage }
});


//Families
export const getFamiliesAction = () => {
  return async (dispatch) => {
    dispatch(getFamiliesActionBegin());
    try {
      const response = await
        sbaAxios({
          url: `${getFamilies}true`,
          method: 'get',
        });
      dispatch(getFamiliesActionSuccess(response));
    }
    catch (error) {
        dispatch(getFamiliesActionFailure(error));
    }
  }
};


export const getFamiliesActionBegin = () => ({
  type: FETCH_FAMILIES_BEGIN,
});

export const getFamiliesActionSuccess = (Family) => ({
  type: FETCH_FAMILIES_SUCCESS,
  payload: { Family },
});

export const getFamiliesActionFailure = (errorMessage) => ({
  type: FETCH_FAMILIES_FAILURE,
  payload: { errorMessage }
});



export const getCommonState = () => {
  return (dispatch) => {
    dispatch(fetchStateBegin());
    sbaAxios({
      url: `${getCommon}${"GetStates"}`,
      method: "get",
    })
      .then((repos) => {
        const EnumData = repos;
        dispatch(fetchStateSuccess(EnumData));
        return EnumData;
      })
      .catch((error) => dispatch(fetchStateFailure(error)));
  };
};
export const fetchStateBegin = () => ({
  type: FETCH_STATES_BEGIN,
});

export const fetchStateSuccess = (state) => ({
  type: FETCH_STATES_SUCCESS,
  payload: { state },
});

export const fetchStateFailure = (errorMessage) => ({
  type: FETCH_STATES_FAILURE,
  payload: { errorMessage }
});


export const getCommonCountries = () => {
  return (dispatch) => {
    dispatch(fetchCountriesBegin());
    sbaAxios({
      url: `${getCommon}${"GetCountries"}`,
      method: "get",
    })
      .then((repos) => {
        const EnumData = repos;
        dispatch(fetchCountriesSuccess(EnumData));
        return EnumData;
      })
      .catch((error) => dispatch(fetchCountriesFailure(error)));
  };
};

export const fetchCountriesBegin = () => ({
  type: FETCH_COUNTRY_BEGIN,
});

export const fetchCountriesSuccess = (country) => ({
  type: FETCH_COUNTRY_SUCCESS,
  payload: { country },
});

export const fetchCountriesFailure = (errorMessage) => ({
  type: FETCH_COUNTRY_FAILURE,
  payload: { errorMessage }
});

